import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_access_input = _resolveComponent("ontos-access-input")!
  const _component_ontos_form_dialog = _resolveComponent("ontos-form-dialog")!

  return (_openBlock(), _createBlock(_component_ontos_form_dialog, _mergeProps(_ctx.heading, {
    "max-width": "800px",
    saving: _ctx.saving,
    "save-disabled": !_ctx.changed || !_ctx.valid,
    dirty: _ctx.changed,
    onSave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('save', _ctx.draft))),
    onClosed: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('closed')))
  }), {
    default: _withCtx(() => [
      _createVNode(_component_ontos_access_input, {
        value: _ctx.draft,
        idea: _ctx.idea,
        workspace: _ctx.workspace,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.draft = $event)),
        onValidity: _cache[1] || (_cache[1] = ($event: any) => (_ctx.valid = $event))
      }, null, 8, ["value", "idea", "workspace"])
    ]),
    _: 1
  }, 16, ["saving", "save-disabled", "dirty"]))
}